import React, { useState, useEffect, useRef } from "react";
//import TodoTask from "./TodoTask"
import TextInput from "../TextField/TextInput";
import IconButton from "../Button/IconButton/IconButton";
import { Controller } from "react-hook-form";
import "./TodoList.css"
import { useFieldArray } from "react-hook-form";
import checkKey from "/src/utils/checkKey";
function TodoList({ registerObject, control, name, checkError, properties_to_add }) {
    const [input, setInput] = useState("")
    const { fields, append, update, prepend, remove, swap, move, insert } = useFieldArray(
        {
            control,
            name: name,
        }
    );
    const todo_ref_input = useRef();
    const modifyInput = (val) => {
        setInput(val);
        registerObject.setValue(`${name}RegisterInput`, val)
        /*
   if (properties_to_add == null) {
       setInput(val);
       registerObject.setValue(`${name}RegisterInput`, val)
   }
   setInput(val);
   registerObject.setValue(`${name}RegisterInput`, val)
   /*
   else {
       setInput({ ...{ value: val }, ...properties_to_add });
       registerObject.setValue(`${name}RegisterInput`, { ...{ value: val }, ...properties_to_add })
   }
   */
        checkErrors()
    }
    const appendTask = () => {
        console.log("EFFECT 2")
        if (input.trim().length != 0) { //trim().length == 0) {

            //if ((input.value != null && input.value.trim().length != 0) || (input.value == null && input.trim().length != 0)) { //trim().length == 0) {
            append({ name: input });
        }
        setInput("")
        todo_ref_input.current.value = "";
        registerObject.setValue(`${name}RegisterInput`, "")
    }
    const updateFields = (e, id, index) => {
        for (let i = 0; i < fields.length; i++) {
            if (fields[i].id === id) {
                fields[i].name = e.target.value;
                /*
                if (properties_to_add != null) {
                    fields[i] = { ...{ value: fields[i].name }, properties_to_add };
                }
                  */
            }
        }

        checkErrors()
    }

    useEffect(() => {
        if (input && input.trim().length === 0) { //trim().length == 0) {
        //if (!input?.value || input.value.trim().length === 0) { //trim().length == 0) {
            checkErrors();
        }
        else {
            registerObject.clearErrors(name);
        }
    }, [fields, input])

    const checkErrors = () => {
        let empty = 0;
        for (let i = 0; i < fields.length; i++) {
            let val = fields[i].name == null ? fields[i][0] : fields[i].name
            if (val.trim().length === 0) {
            //if ((fields[i].name.value != null && (fields[i].name.value == "" || fields[i].name.value.trim().length === 0)) || (fields[i].name?.value == null && (fields[i].name == "" || fields[i].name.trim().length === 0))) {
                empty += 1;
            }
            if (checkError != null){
                checkError(val)
            }
        }
        if (empty == fields.length && !input) {
            registerObject.setError(name, { type: 'custom', message: 'empty' });
        }
        else {
            registerObject.clearErrors(name);
        }
    }

    return (
        <div>
            <div className="raw">
                <TextInput ref={todo_ref_input} placeholder={"Choose your " + (name == "statements" ? "sentences" : "responses")} onChange={(e) => { modifyInput(e.target.value); }} onKeyUp={(e) => { e.preventDefault(); checkKey(e, 13, appendTask) }} />
                <IconButton className="main-iconButton add-hover modalButtons-input" icon="fas fa-plus-circle" onClick={() => appendTask()} />
            </div>
            <ul className="taskList">
                {fields.map((item, index) => {
                    //let defaultValue = item.name?.value == null ? item.name : item.name.value
                    let obj = item.name == null ? item[0] : item.name
                    console.log(item)
                    return (
                        <li key={item.id}>
                            <div className="raw">
                                <TextInput
                                    ref={item.id}
                                    defaultValue={`${obj}`} // make sure to set up defaultValue
                                    {...registerObject.register(`${name}[${index}].name`, { shoudFocused: true })} placeholder={`Choose your ${name.substring(0, name.length - 1)}`}
                                    onChange={(e) => updateFields(e, item.id, index)}
                                />
                                <IconButton className="main-iconButton remove-hover modalButtons-input" icon="fas fa-trash" onClick={() => remove(index)} />
                            </div>
                        </li>
                    );
                })}
            </ul >
        </div >
    );
}


export default TodoList;